import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['Garantía de 7 días', 'Pago seguro', 'Acceso inmediato', 'Material listo para usar desde hoy'];
export function FinalCta() {
  return <section className="bg-stage-deep energy-glow py-16 sm:py-20" aria-labelledby="final-title" data-id="element-70" data-mp="1jcljo8hbjfqd">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-71" data-mp="1eebqg3f5mp7e">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-sageGlow" data-id="element-72" data-mp="1ebxulscnh8ys">
          <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="1o3v7r4n7yb05" /> {productName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-74" data-mp="1o5y5kaum58ff">
          Hecho por especialistas, para docentes de Latinoamérica
        </h2>

        <Countdown light className="mt-8" data-id="element-75" data-mp="1x2oyiedvc75s" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl bg-white p-6 text-left shadow-lift sm:flex-row sm:items-center sm:justify-between" data-id="element-76" data-mp="n6dz559fxnog">
          <p data-id="element-77" data-mp="s6s1c6od23ek">
            <b className="block text-sm uppercase leading-tight text-ink" data-id="element-78" data-mp="x3s70ghat455">{productName}</b>
            <span className="text-sm text-muted" data-id="element-79" data-mp="x64yplcuysve">
              {totalVolumes} tomos + {totalBonuses} bonos · Acceso inmediato
            </span>
          </p>
          <div className="sm:text-right" data-id="element-80" data-mp="163ozyuaq0p60">
            <p className="text-sm text-muted" data-id="element-81" data-mp="162m8ol9hkkpk">
              <span className="mr-2 line-through" data-id="element-82" data-mp="1b2i621nohdw5">{priceBefore}</span>
              <b className="text-base text-ink" data-id="element-83" data-mp="1fujq49r388wq">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-84" data-mp="1fwmcmjt17jwp">
              Quiero mi Mega Pack ahora
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-mutedDark" data-id="element-85" data-mp="1pqmnz3ewpldv">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-86" data-mp="3qtvxuemhj6gr">
              <CheckIcon className="h-4 w-4 text-sageGlow" aria-hidden="true" data-id="element-87" data-mp="3lvkpy9fr3616" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}